import React from "react";
import { twMerge } from "tailwind-merge";

//CSS
import "./searchBar.css";

function SearchBar({
  searchTerm,
  onSearchChange,
  onFocus,
  onBlur,
  placeholder,
  className,
}) {
  const name = twMerge(
    "SearchBar sdhw font-m z-2 text-color-primary",
    className
  );
  return (
    <input
      className={name}
      type="text"
      placeholder={placeholder}
      value={searchTerm}
      onChange={(e) => onSearchChange(e.target.value)}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
}

export default SearchBar;
